// extracted by mini-css-extract-plugin
export default {"liveticker":"liveticker--qwFr7wIrIJ","liveticker__container":"liveticker__container--gl56divb4g","livetickerContainer":"liveticker__container--gl56divb4g"};